// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"627bee73","693":"1444bdd1"}[chunkId] + ".chunk.css";
};